import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';
import {AboutUsComponent} from './about-us.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.landingAboutUs.pageInRouting,
    data: {data: PAGES_AND_PATHS.landingAboutUs},
    component: AboutUsComponent,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('./about-us.module').then(m => m.AboutUsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AboutUsRoutingModule { }
